import { observer } from "mobx-react"
import type { HarnessId } from "../providerEvents/harnessEventTypes"
import type { ThinkingLevel } from "../store/TaskModel"
import { FastModeToggle } from "./FastModeToggle"
import { ModelPicker } from "./ModelPicker"
import { ThinkingPicker } from "./ThinkingPicker"

interface TaskAgentControlsProps {
    selectedModel: string
    onModelChange: (model: string) => void
    thinking: ThinkingLevel
    onThinkingChange: (level: ThinkingLevel) => void
    fastMode: boolean
    onFastModeChange: (enabled: boolean) => void
    harnessId: HarnessId
    side?: "top" | "bottom" | "left" | "right"
    align?: "start" | "center" | "end"
}

export const TaskAgentControls = observer(function TaskAgentControls({
    selectedModel,
    onModelChange,
    thinking,
    onThinkingChange,
    fastMode,
    onFastModeChange,
    harnessId,
    side = "top",
    align = "start",
}: TaskAgentControlsProps) {
    return (
        <div className="flex shrink-0 items-center" aria-label="Agent configuration">
            <ModelPicker value={selectedModel} onChange={onModelChange} harnessId={harnessId} side={side} align={align} />
            <ThinkingPicker value={thinking} onChange={onThinkingChange} side={side} align={align} />
            <FastModeToggle enabled={fastMode} onChange={onFastModeChange} tooltipSide={side} />
        </div>
    )
})
